import { render } from "./SubmissionViewer.vue?vue&type=template&id=2de2df50&scoped=true"
import script from "./SubmissionViewer.vue?vue&type=script&lang=js"
export * from "./SubmissionViewer.vue?vue&type=script&lang=js"

import "./SubmissionViewer.vue?vue&type=style&index=0&id=2de2df50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de2df50"]])

export default __exports__